import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Save, X } from 'lucide-react';

const CATEGORIES = {
  software: { label: 'Software' },
  hosting: { label: 'Hosting' },
  api: { label: 'API Services' },
  marketing: { label: 'Marketing' },
  tools: { label: 'Tools' },
  other: { label: 'Other' },
};

export function CostForm({ form, setForm, tagInput, setTagInput, addTag, removeFormTag, onSave, onCancel, editingId }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-[#0A1628]">{editingId ? 'Edit Cost' : 'Add New Cost'}</h3>
        <button onClick={onCancel}><X className="w-5 h-5 text-gray-400" /></button>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div><Label>Name *</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="e.g. Stripe Fees" className="mt-1" /></div>
        <div><Label>Monthly Amount *</Label><div className="relative mt-1"><span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">$</span><Input type="number" min="0" step="0.01" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="pl-7" placeholder="0.00" /></div></div>
        <div><Label>Category</Label><select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="mt-1 w-full h-10 px-3 rounded-md border border-gray-200 text-sm">{Object.entries(CATEGORIES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}</select></div>
      </div>
      <div><Label>Notes</Label><Input value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Optional notes" className="mt-1" /></div>
      <div>
        <Label>Tags</Label>
        <div className="flex items-center gap-2 mt-1">
          <Input value={tagInput} onChange={(e) => setTagInput(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addTag(); } }} placeholder="Type a tag and press Enter" className="flex-1" />
          <Button type="button" variant="outline" onClick={addTag} className="h-10">Add</Button>
        </div>
        <TagList tags={form.tags} onRemove={removeFormTag} />
      </div>
      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={onCancel}>Cancel</Button>
        <Button onClick={onSave} className="bg-[#84CC16] hover:bg-[#65a30d]"><Save className="w-4 h-4 mr-2" /> {editingId ? 'Update' : 'Add Cost'}</Button>
      </div>
    </div>
  );
}

function TagList({ tags, onRemove }) {
  if (!tags || tags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {tags.map(tag => (
        <span key={tag} className="inline-flex items-center gap-1 px-2.5 py-1 bg-[#014DB7]/10 text-[#014DB7] rounded-lg text-sm font-medium">
          {tag}
          <button onClick={() => onRemove(tag)} className="hover:text-red-500"><X className="w-3 h-3" /></button>
        </span>
      ))}
    </div>
  );
}
